import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, XCircle, ArrowLeft } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="mb-6">
          <CheckCircle className="h-16 w-16 text-green-600 mx-auto" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Payment Successful!
        </h1>

        <p className="text-gray-600 mb-8">
          Thank you for your payment. Your WeRide platform fees have been
          updated.
        </p>

        {/* <button
          onClick={() => navigate("/driver/dashboard")}
          className="w-full flex items-center justify-center gap-2 bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          Return to Dashboard
        </button> */}
      </div>
    </div>
  );
}
